import React, { useEffect } from "react";
import { makeStyles, createStyles } from "@material-ui/core";
import { ITheme } from "../../Layout/themes";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import {
  InvalidTicketContent,
  RejectedContent,
  AcceptedContent
} from "../TicketReceiving/createStaticContent";

const useStyles = makeStyles(({ palette }: ITheme) => {
  return createStyles({
    root: {
      marginBottom: 10
    }
  });
});

export const StatusPage = (env) => {
  const classes = useStyles({});

  return (
    <div className={classes.root}>
      <Switch>
        <Route path="/status/accepted" component={AcceptedContent(env)} />
        <Route path="/status/invalid" component={InvalidTicketContent(env)} />
        <Route path="/status/declined" component={RejectedContent(env)} />
      </Switch>
    </div>
  );
};
